import { images } from './';

const governanca_content = { 
	razao_existir: [
		{
			title: "",
			text: "A representatividade está desvinculada da tradição ou do patrimônio da instituição.",
			image: images.assembleia_icon_1
		},
		{
			title: "",
			text: "Os indicados assumem mandatos por tempo indeterminado, sendo substituídos a critério de cada associado.",
			image: images.assembleia_icon_2
		},
		{
			title: "",
			text: "Há uma assembleia geral no primeiro quadrimestre do ano e assembleias extraordinárias, convocadas quando necessário.",
			image: images.assembleia_icon_3
		}
	],
	responsabilidades: [
		{
			title: "",
			text: "Dirigir e administrar a ANBIMA.",
			image: images.diretoria_icon_1
		},
		{
			title: "",
			text: "Fazer cumprir o estatuto social, as normas e os procedimentos.",
			image: images.diretoria_icon_2
		},
		{
			title: "",
			text: "Fazer cumprir as resoluções da Assembleia Geral.",
			image: images.diretoria_icon_3
		},
		{
			title: "",
			text: "Definir a agenda estratégica, indicando e aprovando as iniciativas prioritárias.",
			image: images.diretoria_icon_4
		}
	],
	president: {
		label: "Presidente",
		name: "Carlos<br />Ambrósio",
		subtitle: "Claritas Administração<br />de Recursos",
		image: images.presidente
	},
	vice_presidents: [
		{
			label: "Vice-presidente",
			name: "Carlos<br />André",
			subtitle: "BB DTVM",
			image: images.vice_presidente1
		},
		{
			label: "Vice-presidente",
			name: "Flavio<br />Souza",
			subtitle: "Itaú Unibanco",
			image: images.vice_presidente2
		},
		{
			label: "Vice-presidente",
			name: "José Eduardo<br />Laloni <span>1</span>",
			subtitle: "ABC Brasil",
			image: images.vice_presidente3
		},
		{
			label: "Vice-presidente",
			name: "Luiz<br />Sorge",
			subtitle: "BNP Paribas Brasil",
			image: images.vice_presidente4
		},
		{
			label: "Vice-presidente",
			name: "Miguel<br />Ferreira",
			subtitle: "Santander",
			image: images.vice_presidente5
		},
		{
			label: "Vice-presidente",
			name: "Pedro<br />Lorenzini",
			subtitle: "Citibank",
			image: images.vice_presidente6
		},
		{
			label: "Vice-presidente",
			name: "Ricardo<br />Almeida",
			subtitle: "Bradesco",
			image: images.vice_presidente7
		},
		{
			label: "Vice-presidente",
			name: "Sérgio<br />Cutolo",
			subtitle: "BTG Pactual",
			image: images.vice_presidente8
		}
	],
	diretores: [
		{
			label: "Diretor",
			name: "Adriano<br />Koelle <span>2</span>",
			subtitle: "BNY Mellon",
			image: images.diretor1
		},
		{
			label: "Diretora",
			name: "Alenir<br />Romanello",
			subtitle: "Caixa Econômica Federal",
			image: images.diretor2
		},
		{
			label: "Diretor",
			name: "Fernando<br />Rabello",
			subtitle: "Safra",
			image: images.diretor3
		},
		{
			label: "Diretor",
			name: "Jan<br />Karsten",
			subtitle: "GPS",
			image: images.diretor4
		},
		{
			label: "Diretor",
			name: "Julio<br />Capua",
			subtitle: "XP Investimentos",
			image: images.diretor5
		},
		{
			label: "Diretor",
			name: "Luiz<br />Chrysostomo",
			subtitle: "Neo Gestão de Recursos",
			image: images.diretor6
		},
		{
			label: "Diretor",
			name: "Luiz Fernando<br />Figueiredo",
			subtitle: "Mauá Investimentos",
			image: images.diretor7
		},
		{
			label: "Diretor",
			name: "Lywal Salles<br />Filho",
			subtitle: "Vinci Partners",
			image: images.diretor8
		},
		{
			label: "Diretor",
			name: "Pedro<br />Juliano <span>2</span>",
			subtitle: "JP Morgan",
			image: images.diretor9
		},
		{
			label: "Diretor",
			name: "Pedro<br />Rudge",
			subtitle: "Leblon Equities",
			image: images.diretor10
		},
		{
			label: "Diretor",
			name: "Reinaldo<br />Lacerda",
			subtitle: "Votorantim",
			image: images.diretor11
		},
		{
			label: "Diretor",
			name: "Saša<br />Markus",
			subtitle: "Renascença DTVM",
			image: images.diretor12
		},
		{
			label: "Diretor",
			name: "Teodoro<br />Lima",
			subtitle: "Credit Suisse",
			image: images.diretor13
		}
	],
	conselho_icons: [
		{
			title: "",
			text: "É composto por três representantes dos associados, eleitos pela Assembleia.",
			image: images.conselho_icon_1
		},
		{
			title: "",
			text: "Reúne-se uma vez por ano para examinar as demonstrações financeiras.",
			image: images.conselho_icon_3
		},
		{
			title: "",
			text: "Pode ser convocado para reuniões extraordinárias.",
			image: images.conselho_icon_2
		},
		{
			title: "",
			text: "Contrata a auditoria externa independente que emite parecer sobre as demonstrações financeiras.",
			image: images.conselho_icon_4
		}
	],
	conselheiros_fiscais: [
		{
			label: "Conselheiro",
			name: "Arnaldo Alves<br />dos Santos",
			subtitle: "Itaú Unibanco",
			image: images.conselheiro_fiscal1
		},
		{
			label: "Conselheiro",
			name: "Luiz Carlos<br />Tozzato",
			subtitle: "ABC Brasil",
			image: images.conselheiro_fiscal2
		},
		{
			label: "Conselheiro",
			name: "Luiz Guilherme<br />de Mendonça",
			subtitle: "Credit Suisse Brasil",
			image: images.conselheiro_fiscal3
		}
	],
	conselho_etica_1_icons: [
		{
			title: "",
			text: "É composto por até sete membros: um presidente, um vice e até cinco conselheiros.",
			image: images.conselho_etica_icon_1
		},
		{
			title: "",
			text: "É eleito pela Assembleia para mandatos de dois anos coincidentes com a Diretoria.",
			image: images.conselho_etica_icon_2
		},
		{
			title: "",
			text: "Não tem número de reuniões preestabelecido.",
			image: images.conselho_etica_icon_3
		}
	],
	conselho_etica_2_icons: [
		{
			title: "",
			text: "Analisa os pedidos de filiação e adesão à ANBIMA.",
			image: images.conselho_etica_icon_4
		},
		{
			title: "",
			text: "Interpreta e aplica o Código de Ética, instaurando e analisando processos de infração e propondo à Diretoria, quando necessário, penalidades aos associados que infringirem suas normas.",
			image: images.conselho_etica_icon_5
		},
		{
			title: "",
			text: "Elabora e submete à Assembleia, por meio da Diretoria, possíveis alterações no Código de Ética.",
			image: images.conselho_etica_icon_6
		}
	],
	conselheiros_etica: [
		{
			label: "Presidente",
			name: "Valdecyr<br />Gomes",
			subtitle: "",
			image: images.conselheiro_etica1
		},
		{
			label: "Vice-presidente",
			name: "Luiz<br />Maia",
			subtitle: "Brookfield Brasil",
			image: images.conselheiro_etica2
		},
		{
			label: "Conselheiro",
			name: "Cassio<br />Von Gal",
			subtitle: "Banco Bocom BBM",
			image: images.conselheiro_etica3
		},
		{
			label: "Conselheiro",
			name: "Luís Fernando<br />Affonso",
			subtitle: "Franklin Templeton",
			image: images.conselheiro_etica4
		},
		{
			label: "Conselheiro",
			name: "Luiz Augusto<br />Candiota",
			subtitle: "Lacan",
			image: images.conselheiro_etica5
		},
		{
			label: "Conselheiro",
			name: "Ricardo<br />Von Döllinger",
			subtitle: "BNP Paribas",
			image: images.conselheiro_etica6
		},
		{
			label: "Conselheira",
			name: "Silmara<br />Baccani",
			subtitle: "BNY Mellon",
			image: images.conselheiro_etica7
		}
	],
	comite_executivo: [
		{
			label: "Superintendente-geral",
			name: "José Carlos<br />Doherty",
			subtitle: "",
			image: images.comite_executivo1
		},
		{
			label: "Superintendente de Educação<br />e Informações Técnicas",
			name: "Ana Claudia<br />Leoni",
			subtitle: "",
			image: images.comite_executivo2
		},
		{
			label: "Superintendente do Selic",
			name: "Francisco<br />Vidinha",
			subtitle: "",
			image: images.comite_executivo3
		},
		{
			label: "Superintendente de<br />Supervisão de Mercados",
			name: "Guilherme<br />Benaderet",
			subtitle: "",
			image: images.comite_executivo4
		},
		{
			label: "Superintendente de<br />Representação Institucional",
			name: "Patricia<br />Herculano",
			subtitle: "",
			image: images.comite_executivo5
		},
		{
			label: "Gerente de Recursos Humanos",
			name: "Eliana<br />Marino",
			subtitle: "",
			image: images.comite_executivo6
		},
		{
			label: "Gerente de Tecnologia<br />da Informação",
			name: "Lina<br />Yajima",
			subtitle: "",
			image: images.comite_executivo7
		},
		{
			label: "Gerente de Comunicação<br />e Marketing",
			name: "Marcelo<br />Billi",
			subtitle: "",
			image: images.comite_executivo8
		},
		{
			label: "Gerente da Assessoria Jurídica",
			name: "Soraya<br />Alves",
			subtitle: "",
			image: images.comite_executivo9
		},
		{
			label: "Gerente da Controladoria<br />e Administração",
			name: "Thiago<br />Baptista",
			subtitle: "",
			image: images.comite_executivo10
		}
	]
};

export { governanca_content };




















